export default __webpack_public_path__ + "static/media/element_72.ce5dd21e.webp";